import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { ParametersService } from "../services/parameters.service";
import { environment } from "../../../environments/environment";
import { MessageService } from "../../shared/message.service";
import { MessageType } from "../../shared/messageType";
import { SecurityService } from "../../shared/security.service";

@Injectable()
// remove this in a subsequent relase
export class LoadParametersGuard  {
  constructor(private router: Router, private parametersService: ParametersService, private messageService: MessageService, private securityService: SecurityService) {

  }
  async canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {

    var authenticated = await this.securityService.isAuthenticated();
    if (!authenticated)
      return false;

    try {
      this.messageService.send(MessageType.ProcessingOn);
      environment.useLegacyAPI = true;
      var legacyParameter = await this.parametersService.getStackParameter("bp.idm.at.legacy-api.enabled");

      if (legacyParameter != null) {
        if (legacyParameter.toLowerCase() == "true")
          environment.useLegacyAPI = true;
        else
          environment.useLegacyAPI = false;
      }
      return true;

    }
    catch (e) {
      console.error(e);
      return true;
    }
    finally {
      this.messageService.send(MessageType.ProcessingOff);
    }
   

  }

}
